<template>
  <f7-page class="page-transaction" @page:afterin="pageMounted">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>MUA CREDIT</f7-nav-title>
      <f7-subnavbar>
        <f7-segmented raised>
          <f7-button :tab-link="`#buy-me`" :tab-link-active="_.isUndefined(this.buy_for_user)">CHO TÔI</f7-button>
          <f7-button :tab-link="`#buy-another`" :tab-link-active="!_.isUndefined(this.buy_for_user)">TẶNG</f7-button>
          <f7-button :tab-link="`#buy-history`">LỊCH SỬ</f7-button>
        </f7-segmented>
      </f7-subnavbar>
    </f7-navbar>
    <f7-tabs>
      <f7-tab id="buy-me" :tab-active="_.isUndefined(this.buy_for_user)">
        <template v-if="form_buy.step === 0">
          <f7-block-title class="mt-2">CHỌN GÓI</f7-block-title>
          <f7-block inset>
            <f7-link v-for="(val, key) in packages" :key="key" @click="form_buy.amount = parseFloat(key.replace('_','')), form_buy.step = 1" class="package">
              <f7-card :class="{'active': form_buy.amount === parseFloat(key.replace('_',''))}" class="mb-1">
                <f7-card-content>
                  <f7-row>
                    <f7-col>
                      <div class="logo">
                        <img :src="require('../assets/images/icon-logo.png')" alt="Icon" class="img-responsive">
                      </div>
                      <div class="description">
                        <h3 class="mt-0 mb-0">{{ parseFloat(key.replace('_', '')) }} USDT</h3>
                        <p class="mt-0 mb-0">{{ val }}</p>
                      </div>
                      <div class="checkbox">
                        <f7-checkbox :checked="form_buy.amount === parseFloat(key.replace('_',''))"></f7-checkbox>
                      </div>
                    </f7-col>
                  </f7-row>
                </f7-card-content>
              </f7-card>
            </f7-link>
          </f7-block>
        </template>
        <template v-if="form_buy.step === 1">
          <f7-list media-list inset class="mt-2">
            <f7-list-item accordion-item id="form-buy-package" :title="`${form_buy.amount} USDT`" :subtitle="`${packages['_' + form_buy.amount]}`" :media="require('../assets/images/icon-logo.png')" @click="form_buy.step = 0"></f7-list-item>
          </f7-list>
          <f7-list inset>
            <f7-list-input
              type="text"
              label="Số dư USDT của bạn"
              placeholder="Số dư USDT"
              :value="user_info.wallet_balance | numeral('0,0[.]00')"
              readonly
              disabled
            >
              <f7-icon ios="f7:money_dollar_circle" slot="media"></f7-icon>
            </f7-list-input>
            <f7-list-input
              type="password"
              label="Mật khẩu"
              placeholder="Mật khẩu"
              :value="form_buy.password"
              @input="form_buy.password = $event.target.value"
            >
              <f7-icon ios="f7:lock" slot="media"></f7-icon>
            </f7-list-input>
          </f7-list>
          <f7-block inset class="mt-0 mb-4">
            <f7-button fill color="primary" @click.prevent="submitFormBuy">
              MUA GÓI
            </f7-button>
          </f7-block>
        </template>
      </f7-tab>
      <f7-tab id="buy-another" :tab-active="!_.isUndefined(this.buy_for_user)">
        <f7-row class="mt-3" v-if="_.isEmpty(user_info.telegram)">
          <f7-col>
            <f7-card>
              <f7-card-content>
                <p>Bạn chưa liên kết Telegram</p>
              </f7-card-content>
              <f7-card-footer>
                <f7-link @click="$f7router.navigate('/tao-ma-gioi-thieu')">Liên kết ngay</f7-link>
              </f7-card-footer>
            </f7-card>
          </f7-col>
        </f7-row>
        <template v-else>
          <template v-if="form_buy_user.step === 0">
            <f7-block-title class="mt-2">CHỌN GÓI</f7-block-title>
            <f7-block inset>
              <f7-link v-for="(val, key) in packages" :key="key" @click="form_buy_user.amount = parseFloat(key.replace('_','')), form_buy_user.step = 1" class="package">
                <f7-card :class="{'active': form_buy_user.amount === parseFloat(key.replace('_',''))}" class="mb-1">
                  <f7-card-content>
                    <f7-row>
                      <f7-col>
                        <div class="logo">
                          <img :src="require('../assets/images/icon-logo.png')" alt="Icon" class="img-responsive">
                        </div>
                        <div class="description">
                          <h3 class="mt-0 mb-0">{{ parseFloat(key.replace('_', '')) }} USDT</h3>
                          <p class="mt-0 mb-0">{{ val }}</p>
                        </div>
                        <div class="checkbox">
                          <f7-checkbox :checked="form_buy_user.amount === parseFloat(key.replace('_',''))"></f7-checkbox>
                        </div>
                      </f7-col>
                    </f7-row>
                  </f7-card-content>
                </f7-card>
              </f7-link>
            </f7-block>
          </template>
          <template v-if="form_buy_user.step === 1">
            <f7-list media-list inset class="mt-2">
              <f7-list-item accordion-item id="form-buy-package-for-user" :title="`${form_buy_user.amount} USDT`" :subtitle="`${packages['_' + form_buy_user.amount]}`" :media="require('../assets/images/icon-logo.png')" @click="form_buy_user.step = 0"></f7-list-item>
            </f7-list>
            <f7-list inset>
              <f7-list-input
                type="text"
                label="Số dư USDT của bạn"
                placeholder="Số dư USDT"
                :value="user_info.wallet_balance | numeral('0,0[.]00')"
                readonly
                disabled
              >
                <f7-icon ios="f7:money_dollar_circle" slot="media"></f7-icon>
              </f7-list-input>
              <f7-list-input
                type="text"
                label="Tài khoản nhận"
                placeholder="Tài khoản nhận"
                :info="form_buy_user.user_referal"
                :value="form_buy_user.buy_for_user"
                @input="form_buy_user.buy_for_user = $event.target.value, form_buy_user.user_checked = 0, form_buy_user.user_referal = ''"
              >
                <f7-icon ios="f7:person" slot="media"></f7-icon>
                <template slot="content-end">
                  <f7-button @click.prevent="searchUsername">
                    <f7-icon :ios="form_buy_user.user_checked ? 'f7:checkmark_rectangle_fill' : 'f7:checkmark_rectangle'" @click.prevent="searchUsername" size="28"></f7-icon>
                  </f7-button>
                </template>
              </f7-list-input>
              <f7-list-input
                label="Mã OTP"
                placeholder="Mã OTP"
                type="text"
                :value="form_buy_user.otp"
                @input="form_buy_user.otp = $event.target.value"
              >
                <f7-icon ios="f7:qrcode" slot="media"></f7-icon>
                <template slot="content-end">
                  <f7-button class="button-otp" outline @click.prevent="generateOTP">Lấy mã</f7-button>
                </template>
              </f7-list-input>
              <f7-list-input
                type="password"
                label="Mật khẩu cấp 2"
                placeholder="Mật khẩu cấp 2"
                :value="form_buy_user.level2_password"
                @input="form_buy_user.level2_password = $event.target.value"
              >
                <f7-icon ios="f7:lock" slot="media"></f7-icon>
              </f7-list-input>
            </f7-list>
            <f7-block inset class="mt-0 mb-4">
              <f7-button fill color="primary" @click.prevent="submitFormBuyUser" :disabled="form_buy_user.user_checked === 0">
                MUA GÓI
              </f7-button>
            </f7-block>
          </template>
        </template>
      </f7-tab>
      <f7-tab id="buy-history">
        <f7-block-title class="mt-2">LỊCH SỬ CREDIT</f7-block-title>
        <f7-list v-if="_.isEmpty(transactions)">
          <f7-list-item title="Chưa có dữ liệu"></f7-list-item>
        </f7-list>
        <f7-list v-else media-list>
          <f7-list-item v-for="(item, idx) in transactions" :key="idx" :title="`${item.amount} Credit`" :subtitle="item.comment" :after="$moment(item.created_at).format('DD/MM/YYYY HH:mm')"></f7-list-item>
        </f7-list>
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>
<style scoped>
.img-logo {
  max-width  : 100%;
  max-height : 50px;
}
.button-otp {
  width : 110px;
}
.package {
  width : 100%;
}
.package .card {
  /*color         : #000000;*/
  width         : 100%;
  margin-bottom : 2px;
  border-radius : 12px;
}
.package .card .card-content {
  padding : 8px 12px;
}
.package .logo {
  display : inline-block;
  float   : left;
}
.package .description {
  display     : inline-block;
  float       : left;
  margin-left : 10px;
}
.package .checkbox {
  float      : right;
  margin-top : 5px;
}
.card.active {
  /*background : #FFD5D5;*/
}
.wallet-box {
  border        : 1px solid #000000;
  background    : rgba(0, 0, 0, 0.05);
  border-radius : 6px;
  padding       : 6px;
}
.card-header-pic .card-header {
  height              : 40vw;
  background-size     : cover;
  background-position : center;
  color               : #FFFFFF;
}
.card-header-pic .card-content-padding .date {
  color : #8E8E93;
}
</style>
<script>
import { mapState } from 'vuex';
import moment from "moment-timezone";

export default {
  props: {
    buy_for_user: String
  },
  data() {
    return {
      transactions: [],
      form_buy: {
        step: 0,
        password: '',
        amount: 40
      },
      form_buy_user: {
        step: 0,
        level2_password: '',
        buy_for_user: '',
        user_referal: '',
        user_checked: 0,
        otp: '',
        amount: 40
      },
      packages: {
        _40: '1000 Credit',
        _120: '3000 Credit (+1000 Bonus)',
        _240: '6000 Credit (+2500 Bonus)',
        _360: '9000 Credit (+4000 Bonus)',
        _480: '12000 Credit (+6000 Bonus)'
      }
    }
  },
  computed: {
    ...mapState(['user_info'])
  },
  methods: {
    getTransactions() {
      let to_date = moment();
      let from_date = to_date.clone().subtract(2, 'weeks');

      this.$store.dispatch('getTransactions', {
            unit: 'credit',
            from_date: from_date.format('YYYY-MM-DD 00:00:00'),
            to_date: to_date.format('YYYY-MM-DD 23:59:59'),
            limit: 999
          })
          .then((data) => {
            this.transactions = data.data;
          })
          .catch((err) => {
            this.$f7.dialog.alert(err, 'LỖI!');
          })
    },
    submitFormBuy() {
      if (this.form_buy.password === '') {
        this.$f7.dialog.alert('Vui lòng nhập mật khẩu', 'LỖI');
        return false;
      }

      this.$f7.dialog.confirm(`Bạn chắc chắn muốn mua gói ${this.packages['_' + this.form_buy.amount]} (${this.form_buy.amount} USDT)`, 'XÁC NHẬN', () => {
        this.$f7.preloader.show();
        this.$store.dispatch('buyCredit', this.form_buy).then(() => {
          return this.$store.dispatch('getMe');
        }).then(() => {
          this.$f7.preloader.hide();
          this.$f7.dialog.alert('Mua Credit thành  công', 'THÔNG BÁO');
        }).catch((err) => {
          this.$f7.preloader.hide();
          this.$f7.dialog.alert(err, 'LỖI');
        })
      });
    },
    submitFormBuyUser() {
      if (this.form_buy_user.level2_password === '') {
        this.$f7.dialog.alert('Vui lòng nhập mật khẩu cấp 2', 'LỖI');
        return false;
      }

      if (this.form_buy_user.buy_for_user === '') {
        this.$f7.dialog.alert('Vui lòng nhập Tài khoản nhận', 'LỖI');
        return false;
      }

      if (this.form_buy_user.user_checked !== 1) {
        this.$f7.dialog.alert('Tài khoản người nhận chưa được xác nhận', 'LỖI');
        return false;
      }

      this.$f7.dialog.confirm(`Bạn chắc chắn muốn mua gói ${this.packages['_' + this.form_buy_user.amount]} (${this.form_buy_user.amount} USDT) cho tài khoản ${this.form_buy_user.buy_for_user}`, 'XÁC NHẬN', () => {
        this.$f7.preloader.show();
        this.$store.dispatch('buyCredit', this.form_buy_user).then(() => {
          return this.$store.dispatch('getMe');
        }).then(() => {
          this.$f7.preloader.hide();
          this.$f7.dialog.alert('Mua Credit thành  công', 'THÔNG BÁO');
        }).catch((err) => {
          this.$f7.preloader.hide();
          this.$f7.dialog.alert(err, 'LỖI');
        })
      });
    },
    generateOTP() {
      this.$f7.dialog.preloader();

      this.$store.dispatch('generateOtpBuyCredit').then(() => {
        this.$f7.dialog.close();
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    searchUsername() {
      this.$f7.dialog.preloader();

      this.$store.dispatch('searchUsername', {
        username: this.form_buy_user.buy_for_user
      }).then((data) => {
        this.$f7.dialog.close();
        if (data.data.data.length === 1) {
          this.form_buy_user.user_checked = 1;
          this.form_buy_user.user_referal = this._.isEmpty(data.data.data[0].referal) ? '' : 'Đại lý : ' + data.data.data[0].referal;
        }
        else{
          this.$f7.dialog.alert('Không tìm thấy tài khoản ' + this.form_buy_user.buy_for_user, 'LỖI!');
        }
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    pageMounted(){
      if (!this._.isUndefined(this.buy_for_user)) {
        this.form_buy_user.buy_for_user = this.buy_for_user;
      }

      this.getTransactions();
    }
  }
};
</script>
